import { Component, Input, OnInit } from '@angular/core';
import { PautasReunioesTelaDTO } from '../../dominios/DTO/pautas-reunioes-tela.DTO';
import { TipoReuniaoModel } from '../../models/tipo-reuniao.model';

@Component({
  selector: 'app-layout-putas-reuniao',
  templateUrl: './layout-putas-reuniao.component.html',
  styleUrls: ['./layout-putas-reuniao.component.css']
})
export class LayoutPutasReuniaoComponent implements OnInit {


  @Input() param: string;


  @Input()  tipoReuniaoModel = new TipoReuniaoModel();


  @Input() telaTabela: PautasReunioesTelaDTO[] = [];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/layout-putas-reuniao/layout-putas-reuniao.component.ts